import { SankeyLayout } from './sankey-layout.model'
import { Segments } from './segments.model'
import { Flows } from './flows.model'

export class SankeyData {
  constructor (clusters = [], demographicCategory) {
    this.clusters = clusters
    this.layout = new SankeyLayout()
    this.segments = new Segments()
    this.flows = new Flows()
    this.stateInfo = new Map()
    this.stageInfo = new Map()
    this.demographicIndexBoundaries = []
    this.selectedSegmentSize = null

    this.selectedSegments = new Segments()
    this.selectedFlows = new Flows()

    this.setClusterDemographicIndexBoundaries(clusters || [])
    this.initializeSegments(demographicCategory)
    this.initializeFlows(demographicCategory)
  }

  setClusterDemographicIndexBoundaries (clusters) {
    let nextDemographicIndex = -1

    for (let index = 0; index < clusters.length; index++) {
      if (clusters[index][0] === nextDemographicIndex) {
        this.demographicIndexBoundaries.push(index)
        nextDemographicIndex++
      }
    }

    this.demographicIndexBoundaries.push(clusters.length)
  }

  getClustersByDemographicCategory (demographicCategory) {
    return this.clusters.slice(
      this.demographicIndexBoundaries[demographicCategory + 1],
      this.demographicIndexBoundaries[demographicCategory + 2]
    )
  }

  initializeSegments (demographicCategory) {
    const clusters = this.getClustersByDemographicCategory(demographicCategory)
    clusters.forEach((cluster) => {
      const [, demographicValue, , size, ...states] = cluster

      if (size === 0) {
        return
      }

      states.forEach((state, stage) => {
        this.segments.add(stage, state, demographicValue, size, cluster)

        const stateInfoKey = this.getStateInfoKey(stage, state)
        this.stateInfo.set(stateInfoKey, {
          totalSize: this.stateInfo.get(stateInfoKey) ? this.stateInfo.get(stateInfoKey).totalSize + size : size
        })

        this.stageInfo.set(stage, {
          totalSize: this.stageInfo.get(stage) ? this.stageInfo.get(stage).totalSize + size : size
        })
      })
    })
  }

  initializeFlows (demographicCategory) {
    const clusters = this.getClustersByDemographicCategory(demographicCategory)
    clusters.forEach(([, demographicValue, , size, ...states]) => {
      if (size === 0) {
        return
      }

      for (let stage = 0; stage < states.length - 1; stage++) {
        this.flows.add(stage, states[stage], states[stage + 1], demographicValue, size)
      }
    })
  }

  clearSelectedSegmentsAndFlows () {
    this.selectedSegments = new Segments()
    this.selectedFlows = new Flows()
  }

  getStateTotalSize (stage, state) {
    const stateInfoKey = this.getStateInfoKey(stage, state)
    const stateInfo = this.stateInfo.get(stateInfoKey)
    return stateInfo && stateInfo.totalSize
  }

  getStageTotalSize (stage) {
    const stageInfo = this.stageInfo.get(parseInt(stage))
    return stageInfo && stageInfo.totalSize
  }

  getStateInfoKey (stage, state) {
    return `${stage}-${state}`
  }

  iterateThroughSegments (iteratorFunction) {
    this.segments.iterate(iteratorFunction)
  }

  iterateThroughSelectedSegments (iteratorFunction) {
    this.selectedSegments.iterate(iteratorFunction)
  }

  iterateThroughFlows (iteratorFunction) {
    this.flows.iterate(iteratorFunction)
  }

  iterateThroughSelectedFlows (iteratorFunction) {
    this.selectedFlows.iterate(iteratorFunction)
  }
}
